import { render, staticRenderFns } from "./PrivacyHangulNandokgi.vue?vue&type=template&id=427a8434&scoped=true"
import script from "./PrivacyHangulNandokgi.vue?vue&type=script&lang=js"
export * from "./PrivacyHangulNandokgi.vue?vue&type=script&lang=js"
import style0 from "./PrivacyHangulNandokgi.vue?vue&type=style&index=0&id=427a8434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a8434",
  null
  
)

export default component.exports